/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { message } from 'antd';
import './style.scss';

// Keep references to the original message functions
const originalSuccess = message.success;
const originalError = message.error;
const originalWarning = message.warning;
const originalInfo = message.info;

// Override message.success
message.success = function (content: any, duration: any = 3) {
  const config = typeof content === 'string' ? { content } : content;

  return originalSuccess({
    ...config,
    duration,
    icon: config.icon || <CheckCircleOutlined />,
    className: config.className || 'success-message alertbox',
  });
};

// Override message.error
message.error = function (content: any, duration: any = 3) {
  const config = typeof content === 'string' ? { content } : content;
  return originalError({
    ...config,
    duration,
    icon: config.icon || <CloseCircleOutlined />,
    className: config.className || 'error-message alertbox',
  });
};

// Override message.warning
message.warning = function (content: any, duration: any = 3) {
  const config = typeof content === 'string' ? { content } : content;

  return originalWarning({
    ...config,
    duration,
    icon: config.icon || <WarningOutlined />,
    className: config.className || 'warning-message alertbox',
  });
};

// Override message.info
message.info = function (content: any, duration: any = 3) {
  const config = typeof content === 'string' ? { content } : content;
  return originalInfo({
    ...config,
    duration,
    icon: config.icon || <InfoCircleOutlined />,
    className: config.className || 'info-message alertbox',
  });
};
